import React from "react";

export const Checkbox = ({
  name,
  className,
  disabled,
  checked,
  onChange,
}: Props) => {
  const resolvedClass = `${staticClass} ${className}`;

  return (
    <input
      name={name}
      type="checkbox"
      className={resolvedClass}
      checked={checked}
      disabled={disabled}
      onClick={(ev) => ev.stopPropagation()}
      onChange={onChange}
    />
  );
};

interface Props {
  name: string;
  checked: boolean;
  disabled?: boolean;
  className?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

const staticClass = `focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded`;
